import Vector from "victor";
import { SingleOperation } from "../operations/Operation";
import { Verb } from "../types/Verb";
import Camera from "../Camera";
import { PenlikeShape2 } from "./PenShape";
import Rect from "../types/Rect";
import { AttributeKey } from "../types/attributes";
import { makeAttributeList } from "../ShapeStore";

export default class AddPenOperation extends SingleOperation {
  constructor(
    newShapeID: string,
    camera: Camera,
    shapePrototype: PenlikeShape2
  ) {
    // Find the min point
    const screenSpaceMin = new Vector(
      shapePrototype.points.reduce(
        (min, p) => Math.min(min, p[0]),
        shapePrototype.points[0][0]
      ) - shapePrototype.strokeWidth, // account for stroke width
      shapePrototype.points.reduce(
        (min, p) => Math.min(min, p[1]),
        shapePrototype.points[0][1]
      ) - shapePrototype.strokeWidth
    );

    // Find the max point
    const screenSpaceMax = new Vector(
      shapePrototype.points.reduce(
        (max, p) => Math.max(max, p[0]),
        shapePrototype.points[0][0]
      ) + shapePrototype.strokeWidth,
      shapePrototype.points.reduce(
        (max, p) => Math.max(max, p[1]),
        shapePrototype.points[0][1]
      ) + shapePrototype.strokeWidth
    );

    const screenSpaceRect = new Rect(screenSpaceMin, screenSpaceMax);

    // Subtract min from all points
    const offsetPoints = shapePrototype.points.map((p) => [
      p[0] - screenSpaceMin.x,
      p[1] - screenSpaceMin.y,
    ]);

    const origin = camera.convertScreenToWorld(screenSpaceMin);
    const size = camera.convertScreenToWorld(screenSpaceMax).subtract(origin);
    super(
      [
        {
          verb: Verb.UpsertSubjectAttributeMany,
          subjectID: newShapeID,
          version: 0,
          attributes: makeAttributeList({ ...shapePrototype }, [
            { key: AttributeKey.IsOpen, value: false },
            { key: AttributeKey.Points, value: offsetPoints },
            {
              key: AttributeKey.BoundingBoxOrigin,
              value: [origin.x, origin.y],
            },
            { key: AttributeKey.BoundingBoxSize, value: [size.x, size.y] },
            {
              key: AttributeKey.BoundingBoxOriginalSize,
              value: [screenSpaceRect.width, screenSpaceRect.height],
            },
          ]),
        },
      ],
      [
        {
          verb: Verb.DeleteShape,
          subjectID: newShapeID,
        },
      ]
    );
  }

  get label(): string {
    return `Draw`;
  }
}
